import { useMemo } from 'react';
import { avoidBreakInside } from '@provider/print';
import { convertColorStringToRgb, invertColorByWCAGContrastRatio } from '@utils/css';
import { heading, hotspotSurface, aspectRatio, img, hotspot } from './organism.print.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ImageHotspotsPrintView(props) {
  const colorOverrides = useMemo(() => {
    const backgroundColor = convertColorStringToRgb(props.component.data.settings.hotspotColor);
    if (!backgroundColor) {
      return undefined;
    }
    return {
      backgroundColor: backgroundColor.toString(),
      textColor: invertColorByWCAGContrastRatio(backgroundColor.toString(), {
        preferredColor: "#fff",
        invertedColor: "#000"
      })
    };
  }, [props.component.data.settings.hotspotColor]);
  return /*#__PURE__*/jsxs("div", {
    ...avoidBreakInside({
      force: true
    }),
    children: [/*#__PURE__*/jsx("h1", {
      className: heading,
      children: props.component.envelope.Title
    }), /*#__PURE__*/jsxs("div", {
      className: aspectRatio,
      style: {
        aspectRatio: `${props.component.data.background?.dimensions.naturalWidth ?? 16} / ${props.component.data.background?.dimensions.naturalHeight ?? 9}`,
        width: `${props.component.data.background?.dimensions.naturalWidth ?? 1110}px`,
        ...hotspotSurface.__override({
          background: colorOverrides?.backgroundColor,
          color: colorOverrides?.textColor
        })
      },
      children: [/*#__PURE__*/jsx("img", {
        src: props.component.data.background?.src,
        alt: "",
        className: img
      }), /*#__PURE__*/jsx("ol", {
        children: props.component.data.hotspots.map((it, index) => /*#__PURE__*/jsx("li", {
          className: hotspot,
          style: {
            top: `${it.position.y * 100}%`,
            left: `${it.position.x * 100}%`
          },
          children: props.component.data.settings.showIndexOnHotspots ? index + 1 : undefined
        }, it.id))
      })]
    })]
  });
}

export { ImageHotspotsPrintView };
//# sourceMappingURL=organism.print.js.map
